import { Melanoma } from './melanoma/melanoma';
import { IMelanomaForm } from './melanoma/melanomaCalcForm.model';
import { Product } from './product.model';

export class CartItem extends Product {
  public id: string;
  public dataCalc: IMelanomaForm | Melanoma;
}
